module.exports = __webpack_public_path__ + "img/ClickForSound_12.25273945.png";